export default {
  home: {
    minute: 'Minute',
    price_info: 'Kostenlos für die ersten {mianfei} Min. Maximal {currencyName}{fengding} pro Tag. Die Kaution wird automatisch einbehalten, wenn die Miete {currencyName}{yajin} erreicht',
    feature_1: 'Kompatibel mit allen Mobiltelefontypen',
    feature_2: 'Kann an jeder anderen Station zurückgegeben werden',
    feature_3: 'Spezielles Design - kabelloses Laden (nur für unterstützte Module)',
    tips_1: 'Ihre Kaution von {currencyName}{yajin} wird Ihnen nach Rückgabe der Powerbank erstattet.',
    yajin_info: 'Maximal {currencyName}{fengding} pro Tag',
    tips_2: 'Kautionsguthaben {currencyName}{yajin} kann gemietet werden, bei Nutzung vollständig erstattet',
    tips_3: 'Der aktuelle Kontostand beträgt {currencyName}{myyue}, direkt nutzbar',
    submit: 'Aufladen',
    borrow: 'Mieten',
    msg_fail_title: 'Fehler',
    msg_fail_content: 'Miete fehlgeschlagen, bitte erneut versuchen',
    msg_rentcount: 'Sie haben derzeit {zujieNum} nicht abgeschlossene Bestellungen',
    goborrow: 'Jetzt aufladen!!!',
    nearby: 'Stationen in der Nähe anzeigen',
    preauth: 'Vorautorisierung',
    shopTime: 'Geschäftszeiten',
    分钟: 'Minute',
    小时: 'Stunde',
    天: 'Tag'
  },
  button: {
    添加新卡: 'Neue Karte hinzufügen',
    delete_card: 'Karte löschen',
    Delete: 'Löschen'
  },
  selectpackage: {
    powerbank: 'Powerbank',
    powerstation: 'Powerstation',
    wifibox: 'WiFi-Box',
    choosepackage: 'Verkehrspaket auswählen',
    minute: 'Minute',
    首次免费: 'Kostenlos für die ersten ',
    最大每日收费: 'Maximalgebühr pro Tag: ',
    devicedeposit: 'Gerätekaution',
    return_will_back: 'Kaution nach Rückgabe des Geräts zurückerstatten',
    lengthofuse: 'Nutzungsdauer',
    amountcharged: 'Akumulierte Gebühr',
    release_powerbank: 'Powerbank freigeben',
    see_pricing: 'Preise anzeigen',
    deposit: 'Kaution',
    agreen: 'Mit dem Fortfahren stimmen Sie unseren ',
    privacy_policy: 'Datenschutzrichtlinie',
    and: ' und ',
    terms_and_conditions: 'AGB zu.',
    per: 'pro'
  },
  wifimall: {
    Select: 'Auswählen',
    subtitle: 'Empfohlene Pakete',
    dayuse: 'Nutzungstage',
    Verify: 'Bestätigen',
    无限流量: 'Unbegrenzt',
    天: 'Tag',
    days: 'Tage',
    useDay: 'Nutzungstage',
    mypackages: 'Vorhandenes Paket auswählen',
    没有更多了: 'Keine weiteren',
    加载中: 'Lädt',
    depositof: 'Enthält eine Kaution von ',
    usagetime: 'Nutzungszeit'
  },
  paymethod: {
    payamount: 'Betrag',
    choosepaymethod: 'Zahlungsmethode wählen',
    addcard: 'Neue Karte hinzufügen',
    confrimpay: 'Zahlung bestätigen',
    借记卡: 'Debitkarte',
    银行卡列表: 'Bankkartenliste'
  },
  login: {
    title: 'Anmelden oder Registrieren',
    code_title: 'SMS-Verifizierung',
    phone_number: 'Telefonnummer',
    verification_code: 'Bitte geben Sie den SMS-Verifizierungscode ein. Wenn kein Code erhalten, versuchen Sie eine andere Anmeldemethode.',
    captcha_code: 'Code',
    send_code: 'Code senden',
    login: 'Anmelden',
    agree: 'Mit der Anmeldung stimmen Sie ',
    readme: 'Nutzungsvereinbarung',
    msg_fail_login: 'Anmeldung fehlgeschlagen',
    msg_success_login: 'Anmeldung erfolgreich',
    msg_fail_user: 'Fehler beim Abrufen der Benutzerinformationen. Erneut versuchen?',
    sign_in_with: 'Anmelden mit',
    no_sms: 'Keine SMS erhalten',
    retry: 'Erneut senden',
    applelogin: 'Mit Apple anmelden',
    otherlogin: 'Weitere Optionen',
    quicklogin: 'Schnellanmeldung',
    mobilelogin: 'Mobilfunkanmeldung',
    emaillogin: 'E-Mail-Anmeldung',
    facelogin: 'Mit Facebook anmelden'
  },
  confirm: {
    'Credit Card': 'Kreditkarte',
    WeChat: 'WeChat',
    'Apple Pay': 'Apple Pay',
    'Google Pay': 'Google Pay',
    'SMS Payment': 'SMS-Zahlung',
    'Idael Pay': 'Idael Pay',
    title: 'Zahlungsbestätigung',
    savenow: 'Jetzt sparen',
    confirmpay: 'Zahlung bestätigen',
    SMSConfirm: 'Bitte zahlen Sie gemäß der SMS auf Ihrem Telefon und klicken Sie zur Bestätigung.',
    pay_label: 'Betrag',
    auth_label: 'Vorautorisierung',
    price_tips: 'Ihr Guthaben kann auf Anfrage ausgezahlt werden. Es kann 1-5 Werktage dauern, bis es auf Ihrem Konto erscheint.',
    auth_tips: 'Eine Vorautorisierung von {0}{1} ist erforderlich. Der tatsächliche Mietbetrag wird bei Rückgabe der Powerbank abgezogen.',
    pay_type: 'Bitte wählen Sie Ihre bevorzugte Zahlungsmethode',
    submit: 'Zahlung bestätigen',
    msg_loading: 'Lädt...',
    msg_fail_title: 'Warnung',
    msg_fail_payment: 'Kautionszahlung fehlgeschlagen',
    msg_fail_order: 'Mietbestellung konnte nicht erstellt werden',
    msg_fail_support: 'System wird nicht unterstützt',
    msg_fail_confirm: 'Bestätigen',
    msg_fail_retry: 'Erneut versuchen',
    msg_fail_cancel: 'Abbrechen',
    msg_none_msg: 'Bitte geben Sie weitere Informationen zur Identifizierung ein'
  },
  mine: {
    title: 'Benutzerprofil',
    wallet: 'Mein Wallet',
    balance: 'Mein Guthaben',
    deposit: 'Kaution',
    wallet_in: 'Aufladen',
    wallet_out: 'Abheben',
    wallet_log: 'Wallet-Verlauf',
    order: 'Bestellung',
    coupon: 'Coupon',
    login_tips: 'Bitte anmelden',
    msg_fail_title: 'Fehler',
    msg_fail_update: 'Änderung fehlgeschlagen, bitte erneut versuchen',
    msg_loading: 'Lädt...',
    msg_fail_user: 'Fehler beim Abrufen der Benutzerinformationen. Erneut versuchen?',
    help: 'Hilfe',
    setting: 'Einstellungen',
    logout: 'Abmelden',
    buy: 'Gerät kaufen',
    aboutus: 'Über uns',
    contactus: 'Kontakt'
  },
  msg: {
    no_phone: 'Telefonnummer ist erforderlich',
    loading: 'Lädt...',
    title: 'Hinweis',
    success: 'Vorgang erfolgreich',
    sendsuccess: 'Erfolgreich gesendet',
    error: 'Unbekannter Fehler, bitte später erneut versuchen.',
    deletecard: 'Möchten Sie diese Karte wirklich löschen?',
    confirm: 'Bestätigen',
    retry: 'Erneut versuchen',
    cancel: 'Abbrechen',
    title_fail: 'Warnung',
    vieworder: 'Bestellung anzeigen',
    success_payment: 'Zahlung abgeschlossen',
    success_buy: 'Kauf abgeschlossen',
    fail_payment: 'Zahlung fehlgeschlagen',
    keyword: 'Schlüsselwort',
    nodata: 'Keine Daten',
    copysuccess: 'Kopiert erfolgreich',
    notopen: 'Noch nicht geöffnet',
    devicenotactivated: 'Gerät nicht aktiviert',
    pickup_fail: 'Gerät konnte nicht abgerufen werden. Bitte später erneut versuchen',
    msg_none_name: 'Bitte geben Sie Ihren Vornamen ein',
    msg_none_email: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    msg_none_mobile: 'Bitte geben Sie Ihre Telefonnummer ein',
    msg_none_nation: 'Bitte geben Sie Ihr Land ein',
    msg_none_msg: 'Bitte geben Sie weitere Informationen zur Identifizierung ein',
    msg_fail_choosepackage: 'Bitte wählen Sie ein Paket-Abholgerät',
    geolocationfailed: 'Fehler: Der Geolocation-Dienst ist fehlgeschlagen.'
  },
  result: {
    title: 'Ergebnisbestätigung',
    price_plan: 'Ladestandard',
    msg_success: 'Erfolgreich gemietet',
    msg_tips_loading: 'Powerbank wird herausgegeben, bitte warten...',
    msg_result_loading: 'Zahlungsergebnis wird bestätigt...',
    msg_fail_confirm: 'Bestätigen',
    btn_usage: 'Nutzungshinweis',
    btn_return: 'Rückgabehinweis',
    deposit: 'Kaution',
    msg_fail_content: 'Anfrage fehlgeschlagen, bitte erneut versuchen',
    price_label: 'pro Stunde',
    price_info: 'Kostenlos für die ersten {mianfei} Min, max. {ccurrency}{fengding} pro Tag, Kaution wird automatisch abgezogen bei Erreichen von {ccurrency}{yajin}',
    tips_1: 'Bitte entnehmen Sie Powerbank <span class="number">Nr. {number}</span> wie abgebildet',
    tips_2: 'Bitte ordnen Sie die Kabel und setzen Sie die Powerbank mit dem <span class="highlight">[Pfeil nach unten]</span> ein when returning',
    msg_note_usage: 'Die Powerbank verfügt über 3 Kabeltypen und kabelloses Laden, bitte nach Bedarf verwenden.',
    msg_note_return: 'Bitte ordnen Sie die Kabel und setzen Sie die Powerbank mit dem [Pfeil nach unten] ein.',
    return_info: 'Bei Rückgabe: Kabel ordnen und die Seite mit den Metallkontakten in eine leere Buchse bis zum Boden stecken.'
  },
  result_msg: {
    loading: 'Lädt...',
    refresh: 'Aktualisieren'
  },
  order: {
    title: 'Mietbestellung',
    in_use: 'In Nutzung',
    ended: 'Beendet',
    enter_order_email: 'Bitte E-Mail eingeben',
    msg_error: 'Anfrage fehlgeschlagen'
  },
  order_item: {
    order_number: 'Nr.',
    venue_rented: 'Abholstation',
    time_rented: 'Abholzeit',
    venue_returned: 'Rückgabestation',
    time_returned: 'Rückgabezeit',
    charge_standard: 'Ladestandard',
    charge_standard_info: '{pJifei} {pCurrency} pro Stunde (erste {pMian} Min kostenlos)',
    rent_occurred: 'Mietkosten',
    returned: 'Zurückgegeben',
    unreturned: 'Nicht zurückgegeben',
    type_0: 'Nicht abgeschlossen',
    type_1: 'In Miete',
    type_2: 'Storniert',
    type_3: 'Zurückgegeben',
    type_4: 'Fehler aufgetreten',
    type_5: 'Überzogen',
    min: 'Min',
    payment: 'Zahlung'
  },
  setting: {
    title: 'Einstellungen',
    lang: 'Sprache'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Guthaben aufladen',
    price_label: 'Aufladebetrag',
    price_placeholder: 'Bitte Aufladebetrag eingeben',
    balance: 'Aktuelles Guthaben',
    price_auto: 'Zahlungsbetrag wählen',
    price_tips: 'Ihr Guthaben kann auf Anfrage ausgezahlt werden. Es kann 1-5 Werktage dauern.',
    submit: 'Absenden',
    loading: 'Lädt...',
    paying: 'Weiter zur Zahlungsseite...',
    msg_title: 'Hinweis',
    msg_fail_order: 'Auftragsbestellung fehlgeschlagen',
    msg_fail_payment: 'Zahlung fehlgeschlagen',
    msg_fail_retry: 'Erneut versuchen',
    选择充值金额: 'Aufladebetrag wählen',
    输入充值金额: 'Aufladebetrag eingeben',
    确认充值: 'Aufladen bestätigen'
  },
  wallet_out: {
    title: 'Auszahlung',
    price_label: 'Auszahlungsbetrag',
    price_placeholder: 'Bitte Auszahlungsbetrag eingeben',
    balance: 'Aktuelles Guthaben',
    balance_all: 'Alles abheben',
    deposit: 'Kaution',
    deposit_tips: 'Es liegt eine Mietbestellung vor. Die Kaution von {pcurrencyName}{pyajin} ist nicht erstattbar',
    submit: 'Absenden',
    apply: 'Anwenden',
    confirm: 'Bestätigen',
    loading: 'Lädt...',
    msg_fail_price: 'Auszahlungsbetrag ist falsch',
    msg_fail_balance: 'Auszahlungsbetrag darf das aktuelle Guthaben nicht überschreiten',
    msg_fail_submit: 'Bitte alle Informationen ausfüllen',
    msg_title: 'Fehler',
    msg_success_content: 'Erstattung erfolgreich beantragt',
    confirmtitle: 'Hinweis',
    confirmcontent: 'Das aktuelle Wallet unterstützt keine Barabhebung. Bitte kontaktieren Sie uns für manuelle Erstattung',
    payee_name: 'Empfängername',
    payee_bankcard: 'Bankkartennummer',
    payee_phone: 'Telefon',
    cancelText: 'Abbrechen',
    confirmText: 'Erneut bewerben',
    退款金额: 'Erstattungsbetrag'
  },
  map: {
    title: 'Geräte in der Nähe',
    result_msg: 'Keine Geräte in der Nähe gefunden',
    msg_title: 'Fehler',
    no_support: 'Entschuldigung! Ihr Browser unterstützt keine Standortbestimmung',
    my_position: 'Mein Standort',
    distance: 'Entfernung:',
    shop_time: 'Stunden',
    free: 'Ausleihbar',
    return: 'Rückgabefähig',
    shop_title: 'Händlerdetails',
    address: 'Adresse',
    go_here: 'Hierhin navigieren'
  },
  scanOrder: {
    viewflowdetail: 'Nutzungsdetails anzeigen',
    confirmpickup: 'Abholbestätigung',
    QRpickup: 'QR-Code Abholung',
    取机中: 'Abholung',
    scanQR: 'QR-Code scannen zum Binden',
    qrCodePickup: 'QR-Code Abholung',
    orderNo: 'Bestellnr.',
    startingTime: 'Startzeit',
    endTime: 'Endzeit',
    packageStatus: 'Paketstatus',
    无限流量: 'Unbegrenzt',
    天: 'Tag',
    days: 'Tage',
    type_0: 'Unbenutzt',
    type_1: 'Zu aktivieren',
    type_2: 'Aktiviert',
    type_3: 'Widerrufen',
    type_4: 'Erstattet',
    type_9: 'Beendet',
    type_33: 'Unbezahlt',
    type_88: 'Storniert',
    inputserialNumber: 'Bitte Seriennummer des Geräts eingeben',
    pickupsuccess: 'Gerät erfolgreich abgeholt',
    continuepay: 'Zahlung fortsetzen'
  },
  borrowSuccess: {
    success: 'Miete erfolgreich',
    renewalTraffic: 'Verkehr verlängern',
    viewOrder: 'Bestellung anzeigen',
    HowUseDevice: 'Gerät nutzen',
    download_tips: 'Sie können Ihre E-Mail angeben und wir senden Ihnen die Bestelldetails zu',
    download_tips2: 'Weitere Rückgabeorte finden Sie in der App.',
    download: 'Herunterladen',
    loading_title: 'Powerbank wird freigeschaltet',
    loading_tips: 'Bitte warten...',
    send: 'Senden'
  },
  packageOrder: {
    viewdetail: 'Details anzeigen',
    buynow: 'Jetzt kaufen',
    isrent: 'Ist das Gerät gemietet?',
    timelimited: 'Zeitlich begrenztes Angebot'
  },
  packageDetail: {
    WiFiName: 'WiFi-Name',
    WiFiPassword: 'WiFi-Passwort',
    batteryLife: 'Akkulaufzeit',
    Signal: 'Signal',
    orderNo: 'Bestellnr.',
    startingTime: 'Startzeit',
    endTime: 'Endzeit',
    packageStatus: 'Paketstatus',
    usedTraffic: 'Genutztes Volumen',
    Renewals: 'Verkehr kaufen',
    inuse: 'In Nutzung'
  },
  orderDetail: {
    price1: '{pCurrencyName}{pJifei} pro {pJifeiDanwei}{priceUnit}',
    price2: 'Maximal {pCurrencyName}{pFengding} pro 24 Stunden',
    price3: 'Nicht-Rückgabe-Gebühr von {pCurrencyName}{overtimeAmount}',
    venuerented: 'Abholstation',
    venuereturned: 'Rückgabestation',
    timerented: 'Mietzeit',
    timereturned: 'Rückgabezeit',
    powerbankid: 'Powerbank-ID',
    getreceipt: 'BON ERHALTEN',
    buypowerbank: 'Diese Powerbank kaufen',
    usetime: 'Nutzungszeit',
    estimatedamount: 'Geschätzter Betrag',
    feerule: 'Gebührenregel',
    payment: 'Zahlung',
    orderNo: 'Bestellnr.',
    trafficDetails: 'Paketvolumen anzeigen',
    Renewals: 'Verlängerungen',
    FeeSchedule: 'Gebührenübersicht',
    HowToUse: 'Nutzungshinweise',
    LeaseMerchant: 'Vermietungsstation',
    startTime: 'Startzeit',
    ReturningMerchants: 'Rückgabestation',
    EndTime: 'Endzeit',
    Deposit: 'Kaution',
    fee1: 'Gerätekaution 500€',
    fee2: 'Rückgabe innerhalb von 7 Tagen nach Mietende, minus 10€/Tag/Gerät.',
    fee3: 'Rückgabe innerhalb von 7 Tagen nach Mietende: 200€/Gerät werden abgezogen.',
    fee4: 'Kaution wird automatisch einbehalten, wenn das Gerät nicht mehr als 15 Tage nach Mietende zurückgegeben wird.',
    rentagain: 'Erneut mieten',
    onrental: 'In Miete',
    revoked: 'Widerrufen',
    returned: 'Zurückgegeben',
    issue: 'Problem',
    overtimereturn: 'Überzogen'
  },
  pickUp: {
    orderNo: 'Bestellnr.',
    startingTime: 'Startzeit',
    endTime: 'Endzeit',
    packageStatus: 'Paketstatus',
    confirmationOfPickup: 'Abholbestätigung'
  },
  aboutus: {
    title: 'Über uns',
    desc1: 'BajieCharging ist eine Marke für gemeinsame Powerbank-Lösungen der Shenzhen Bajie Charging Technology Co., Ltd. Seit der Gründung 2018 konzentriert sich das Unternehmen auf Forschung und Betrieb intelligenter Terminalgeräte im Bereich der Sharing Economy. Durch kontinuierliche technologische Innovation wurden verschiedene intelligente Geräte wie gemeinsame Powerbanks, intelligente Schließfächer, globales WiFi und portable Energiespeicher entwickelt.',
    desc2: 'BaJie Charging hat ein ausgereiftes OEM-Kooperationsmodell für Geschäftspartner entwickelt. Wir bieten Geräte und technischen Support, während Sie Ihren eigenen Powerbank-Service betreiben.',
    contactustitle: 'Möchten Sie Partner von ChargeNow werden? Kontaktieren Sie uns——',
    formtitle: 'Haben Sie eine Frage? Kontaktieren Sie uns!',
    submit: 'Absenden',
    name: 'Name',
    email: 'E-Mail',
    tel: 'Tel',
    nation: 'Land',
    message: 'Nachricht'
  },
  contactus: {
    title: 'Kontakt',
    desc1: 'ChargeNow ist eine Marke für Powerbank-Sharing-Lösungen der Shenzhen Bajie Charging Technology Co., Ltd. ChargeNow betreibt einen globalen Powerbank-Sharing-Service mit Franchisenehmern weltweit.',
    desc2: 'Wenn Sie an einer Franchise-Partnerschaft interessiert sind, kontaktieren Sie bitte unser Hauptsitz in China.',
    contactustitle: 'China Hauptsitz',
    contactussubtitle: 'Gebäude 5, 2.–4. Etage, Fuzhong Industrial Park, Huaide Community, Fuyong Subdistrict, Shenzhen PLZ: 518128',
    contactusinfotitle: 'Für Endnutzer, die Probleme beim Ausleihen einer Powerbank haben, wenden Sie sich bitte an Ihren lokalen Franchisegeber:',
    method1: 'GRANSOL BRASIL',
    methoddesc1: 'Av. Ana Costa, 61 EV 506 Santos/SP CEP 11060-001',
    method2: 'Kasachstan Region',
    methoddesc2: 'Stadt Aktau'
  },
  rentcost: {
    rentcosttitle: 'Was kostet die Miete?',
    price1: '{currency} {jifei} pro {jifeiDanwei} {priceUnit}',
    price2: '{currency} {fengding} pro Tag',
    tip1: 'Wenn Sie die Powerbank nicht innerhalb von {overtime} zurückgeben, werden {overtimeAmount} {currency} berechnet und Sie müssen sie nicht zurückgeben.',
    tip2: 'Ein Tag Miete = 24 Stunden ab Abholzeit.',
    tip3: 'Wir erheben eine Kaution von {yajin} {currency}, die bei Rückgabe erstattet wird.',
    tip4: 'Einige Stationen bieten kostenlose Stunden oder Rabatte. Viel Spaß!',
    Days: 'Tage',
    Hours: 'Stunden',
    Minutes: 'Minuten',
    free: '{mianfei} Minuten kostenlos',
    willcharged: 'Ihnen werden {currency} {money} berechnet'
  },
  payment: {
    title: 'Bankkartenzahlung',
    cardNumber: 'Kartennummer',
    cardNumberPlaceholder: 'Kartennummer eingeben',
    cardHolder: 'Name des Karteninhabers',
    cardHolderPlaceholder: 'Name eingeben',
    expiryDate: 'Ablaufdatum',
    cvv: 'CVV',
    cvvPlaceholder: 'CVV',
    cardType: 'Kartentyp',
    selectCardType: 'Kartentyp wählen',
    creditCard: 'Kreditkarte',
    debitCard: 'Debitkarte',
    month: 'Monat',
    year: 'Jahr',
    payNow: 'Jetzt zahlen',
    processing: 'Verarbeitung...',
    success: 'Zahlung erfolgreich',
    failed: 'Zahlung fehlgeschlagen',
    close: 'Schließen',
    paymentSuccess: 'Zahlung erfolgreich! Vielen Dank für Ihren Einkauf.',
    paymentFailed: 'Zahlung fehlgeschlagen, bitte erneut versuchen oder andere Zahlungsmethode verwenden.',
    networkError: 'Netzwerkfehler, bitte Verbindung prüfen und erneut versuchen.'
  },
  validation: {
    cardNumberRequired: 'Kartennummer ist erforderlich',
    cardNumberDigitsOnly: 'Kartennummer darf nur Ziffern enthalten',
    unsupportedCardType: 'Kartentyp wird nicht unterstützt',
    invalidCardLength: 'Kartennummer muss {lengths} Ziffern haben',
    invalidCardNumber: 'Ungültige Kartennummer',
    cardHolderRequired: 'Name des Karteninhabers ist erforderlich',
    expiryRequired: 'Ablaufdatum ist erforderlich',
    cardExpired: 'Karte ist abgelaufen',
    cvvRequired: 'CVV ist erforderlich',
    cvvDigitsOnly: 'CVV darf nur Ziffern enthalten',
    invalidCvvLength: 'CVV muss {length} Ziffern haben',
    cardTypeRequired: 'Kartentyp ist erforderlich'
  }
}
